'use client';

import { type CSSProperties, type HTMLAttributes, type ReactNode, useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

type StickyHeaderShellProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  scrolledStyle?: CSSProperties;
};

export function StickyHeaderShell({
  children,
  className,
  scrolledStyle,
  style,
  ...props
}: StickyHeaderShellProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      data-scrolled={isScrolled ? 'true' : 'false'}
      className={cn(
        'transition-[box-shadow,border-color] duration-200',
        className,
      )}
      style={{
        ...(style ?? {}),
        ...(isScrolled ? scrolledStyle : null),
        boxShadow: isScrolled ? 'var(--site-shadow-nav)' : 'none',
      }}
      {...props}
    >
      {children}
    </div>
  );
}
